import Cookies from 'js-cookie';
const baseConfig = {
    ua: window.navigator.userAgent.toLowerCase(),
    auth: Cookies.get('_PMAUTH') ? JSON.parse(Cookies.get('_PMAUTH')) : false,
    hostname: window.location.hostname,
    hostList: [
        'beta.pmcaff.com',
        'www.pmcaff.com',
        'pmcaff.com',
        'coffee.pmcaff.com',
    ],
    isProduct() {
        let inArr = false;
        this.hostList.forEach(item => {
            if (this.hostname == item) {
                inArr = true;
            }
        });
        return inArr;
    },
    getApiUrl() {
        return this.isProduct() ? 'https://api.pmcaff.com/api/v0/' : 'http://pmcaff-api.test.pmcaff.net/api/v0/';
    },
    isPmcaffCom() {
        return /\.pmcaff\.com/.test(this.hostname);
    },
    isPmcaffNet() {
        return /\.pmcaff\.net/.test(this.hostname);
    },
    getCookieDomain() {
        if (this.isPmcaffCom()) {
            return '.pmcaff.com';
        } else if (this.isPmcaffNet()) {
            return '.pmcaff.net';
        } else {
            return this.hostname;
        }
    },
    getPmUrl() {
        if (this.isProduct()) {
            return 'https://www.pmcaff.com/';
        } else if (this.isPmcaffNet()) {
            return 'http://pmcaff-front.test.pmcaff.net/';
        } else {
            return `http:\/\/${window.location.hostname}:8080/`;
        }
    },
    getCoUrl() {
        if (this.isProduct()) {
            return 'https://coffee.pmcaff.com/';
        } else if (this.isPmcaffNet()) {
            return 'http://coffee.test.pmcaff.net/';
        } else {
            return `http:\/\/${window.location.hostname}:9070/`;
        }
    },
    isIOSApp() {
        return this.ua.indexOf('pmcaff-ios') > -1;
    },
    isAndroidApp() {
        return this.ua.indexOf('pmcaff-android') > -1;
    },
    IOSAppVersion() {
        return this.ua.match(/pmcaff-ios-(\d+\.\d+.\d+)/) && this.ua.match(/pmcaff-ios-(\d+\.\d+.\d+)/)[1];
    },
    AndroidAppVersion() {
        return this.ua.match(/pmcaff-android-(\d+\.\d+.\d+)/) && this.ua.match(/pmcaff-android-(\d+\.\d+.\d+)/)[1];
    },
    isNewAndroidApp() {
        return this.AndroidAppVersion() && this.AndroidAppVersion().split('.')[0] > 2 || false;
    },
    isNewIOSApp() {
        return this.IOSAppVersion() && this.IOSAppVersion().split('.')[0] > 1 || false;
    },
    isWV() {
        return this.ua.indexOf(/wv/i) > -1;
    },
}

export default baseConfig;


// WEBPACK FOOTER //
// ./src/config.js